import {
	UPDATE_SEARCH_STATE,
	UPDATE_FILTER,
	UPDATE_FILTER_VALUES,
} from '../actionTypes';

const initialState = {
	products: [],
	searchParams: {
		value: '',
		dateRange: {
			startDate: null,
			endDate: null
		}
	},
	filter: {},
	filterAttributes: {},
	filterValues: {},
	configPagination: {},
	geo: {},
	city: '',
	chosenGeo: null,
	searchComponents: {},
	productAttributes: {},
	showFilter: {},
	paginationIndex: 1,
	loading: true,
};

export default function (state = initialState, action) {
	switch (action.type) {
	case UPDATE_SEARCH_STATE: {
		const { content } = action.payload;
		return {
			...state,
			...content,
		};
	}
	case UPDATE_FILTER: {
		const { content } = action.payload;
		return {
			...state,
			...content,
		};
	}
	case UPDATE_FILTER_VALUES: {
		const { content } = action.payload;
		const newState = {
			...state,
			...content,
			filterValues: {
				...state.filterValues,
				...content.filterValues,
			}
		};
		return newState;
	}
	default:
		return state;
	}
}
